import { TypeGames } from "../../../TopX/types/types";
import { StatusEnum } from "../../Enums/StatusEnum";

export default class PredictionsFilters {
    public limit: number = null;
    public startAfter: string = null;
    public status: StatusEnum[] = null;
    public type: TypeGames = null;
    public matchIds: string[] = null;
    public gameIds: string[] = null;

    constructor(filters?: any) {
        this.limit = filters?.limit || null;
        this.startAfter = filters?.startAfter || null;
        this.status = filters?.status || null;
        this.type = filters?.type || null;
        this.matchIds = filters?.matchIds || null;
        this.gameIds = filters?.gameIds || null;
    }

    public constructFiltersUrl = () => {
        let url = "";
        let correctStatus: boolean = false;

        if (this.status) {
            correctStatus = Object.values(StatusEnum).some(status => {
                return this.status.includes(status)
            });
        }

        if (this.limit) {
            url += '&';
            url += `limit=${this.limit}`;
        }
        if (this.startAfter) {
            url += '&';
            url += `start_after=${this.startAfter}`;
        }
        if (this.status && correctStatus) {
            url += '&';
            url += `status=${this.status.join(",")}`;
        }
        if (this.type) {
            url += '&';
            url += `game_types=${this.type}`;
        }
        if (this.matchIds && this.matchIds.length > 0) {
            url += '&';
            url += `match_ids=${this.matchIds.join(",")}`;
        }
        if (this.gameIds && this.gameIds.length > 0) {
            url += '&';
            url += `game_ids=${this.gameIds.join(",")}`;
        }

        return url;
     };
}